
export async function instantiate(imports={}, runInitializer=true) {
    imports['_cachedJsObjects_'] = imports['_cachedJsObjects_'] ?? new WeakMap();
    const cachedJsObjects = imports['_cachedJsObjects_'];

    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }


    imports['./skiko.mjs'] = imports['./skiko.mjs'] ?? await import('./skiko.mjs');
    imports['@js-joda/core'] = imports['@js-joda/core'] ?? await import('@js-joda/core');

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.ArrayBuffer_$external_class_instanceof' : (x) => x instanceof ArrayBuffer,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => { return { mode }; },
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => { return { passive, once, capture }; },
        'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
        'org.w3c.dom.closed_$external_prop_getter' : (_this) => _this.closed,
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
        'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
        'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
        'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
        'org.w3c.dom.port_$external_prop_getter' : (_this) => _this.port,
        'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.platform_$external_prop_getter' : (_this) => _this.platform,
        'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.w3c.dom.vendor_$external_prop_getter' : (_this) => _this.vendor,
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.onLine_$external_prop_getter' : (_this) => _this.onLine,
        'org.w3c.dom.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
        'org.w3c.dom.__convertKotlinClosureToJsClosure_(()->Js?)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Js?)'](f, )),
        'org.w3c.dom.clearTimeout_$external_fun' : (_this, p0, isDefault0) => _this.clearTimeout(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.setInterval_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setInterval(p0, isDefault0 ? undefined : p1, ...p2, ),
        'org.w3c.dom.clearInterval_$external_fun' : (_this, p0, isDefault0) => _this.clearInterval(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
        'org.w3c.dom.MessageEvent_$external_class_get' : () => MessageEvent,
        'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
        'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
        'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
        'org.w3c.dom.WebSocket_$external_fun' : (p0, p1, isDefault0) => new WebSocket(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
        'org.w3c.dom.onopen_$external_prop_setter' : (_this, v) => _this.onopen = v,
        'org.w3c.dom.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'org.w3c.dom.onclose_$external_prop_setter' : (_this, v) => _this.onclose = v,
        'org.w3c.dom.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
        'org.w3c.dom.Companion_$external_object_getInstance_2' : () => WebSocket,
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.CloseEvent_$external_class_instanceof' : (x) => x instanceof CloseEvent,
        'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
        'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
        'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
        'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
        'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.files.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.files.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
        'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
        'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
        'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
        'org.w3c.files.onabort_$external_prop_setter' : (_this, v) => _this.onabort = v,
        'org.w3c.files.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.clipboard_$external_prop_getter' : (_this) => _this.clipboard,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
            container.style.setProperty("--compose-internal-web-backing-input-left", left);
            container.style.setProperty("--compose-internal-web-backing-input-top", top);
            container.style.setProperty("--compose-internal-web-backing-input-width", width);
            container.style.setProperty("--compose-internal-web-backing-input-height", height)
         },
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
        'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'androidx.compose.ui.platform.deleteContentBackwardSize_$external_prop_getter' : (_this) => _this.deleteContentBackwardSize,
        'androidx.compose.ui.platform.deleteContentBackwardSize_$external_prop_setter' : (_this, v) => _this.deleteContentBackwardSize = v,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
        'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'com.stutem.app.JsDate_$external_fun' : () => new Date(),
        'com.stutem.app.JsDate_$external_fun_1' : (p0) => new Date(p0),
        'com.stutem.app.getFullYear_$external_fun' : (_this, ) => _this.getFullYear(),
        'com.stutem.app.getMonth_$external_fun' : (_this, ) => _this.getMonth(),
        'com.stutem.app.getDate_$external_fun' : (_this, ) => _this.getDate(),
        'com.stutem.app.getHours_$external_fun' : (_this, ) => _this.getHours(),
        'com.stutem.app.getMinutes_$external_fun' : (_this, ) => _this.getMinutes(),
        'com.stutem.app.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'com.stutem.app.classroom.launchClassroom' : (serverUrl, sessionId, token, recordingsOnly, userId, restoring, chatOnly, onClosed, courseId, batchId) => {
          const base = new URL(serverUrl);
          if (base.origin !== window.location.origin) { if (!restoring) window.alert('Open StuTem on the same server as your classroom.'); return; }
          const storageKey = 'stutem.classroom.resume';
          let saved = null;
          try { saved = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
          if (restoring) {
            if (!saved) return;
            if (saved.userId !== userId || typeof saved.sessionId !== 'string' || !saved.sessionId) {
              try { sessionStorage.removeItem(storageKey); } catch {}
              return;
            }
            courseId = saved.courseId; batchId = saved.batchId;
            sessionId = saved.sessionId; recordingsOnly = saved.recordingsOnly === true; chatOnly = saved.chatOnly === true;
          }
          // Compose renders into a body shadow root; light-DOM children are not displayed.
          const host = document.body.shadowRoot || document.body;
          const existing = host.querySelector('#stutem-classroom');
          // Opening a class again while its call is minimized brings the call back to full view.
          if (existing) { if (!restoring) existing.contentWindow.postMessage(JSON.stringify({type:'stutem-classroom-expand'}), base.origin); return; }
          const resumeJoined = restoring && saved.joined === true && !recordingsOnly && !chatOnly;
          // Store navigation only. Authentication always comes from the restored app session.
          const entry = { courseId, batchId, sessionId, userId, recordingsOnly, chatOnly, joined: resumeJoined };
          function persist() { try { sessionStorage.setItem(storageKey, JSON.stringify(entry)); } catch {} }
          persist();
          const frame = document.createElement('iframe'); frame.id = 'stutem-classroom';
          frame.title = 'StuTem classroom'; frame.src = base.origin + '/classroom/index.html';
          frame.allow = 'camera; microphone; display-capture; autoplay; fullscreen';
          const fullStyle = 'position:fixed;inset:0;width:100%;height:100%;border:0;z-index:2147483646;background:#101828';
          frame.style.cssText = fullStyle;
          // Minimized calls float over the app so it stays usable (and presentable) during class.
          let minimized = false, miniLeft = null, miniTop = null;
          function placeMini() {
            const width = Math.min(360, window.innerWidth - 16), height = Math.min(270, window.innerHeight - 16);
            if (miniLeft === null) { miniLeft = window.innerWidth - width - 16; miniTop = window.innerHeight - height - 16; }
            miniLeft = Math.max(8, Math.min(miniLeft, window.innerWidth - width - 8));
            miniTop = Math.max(8, Math.min(miniTop, window.innerHeight - height - 8));
            frame.style.cssText = 'position:fixed;left:' + miniLeft + 'px;top:' + miniTop + 'px;width:' + width + 'px;height:' + height +
              'px;border:1px solid #3b4a63;border-radius:12px;box-shadow:0 12px 32px rgba(0,0,0,.45);z-index:2147483646;background:#101828';
          }
          function resize() { if (minimized) placeMini(); }
          function receive(event) {
            if(event.source !== frame.contentWindow || event.origin !== base.origin) return;
            if(event.data === 'stutem-classroom-ready') frame.contentWindow.postMessage(JSON.stringify({type:'stutem-classroom-open',sessionId,token,recordingsOnly,chatOnly,resumeJoined}),base.origin);
            if(event.data === 'stutem-classroom-joined') { entry.joined = true; persist(); }
            if(event.data === 'stutem-classroom-left') { entry.joined = false; persist(); }
            if(event.data === 'stutem-classroom-minimize') { minimized = true; placeMini(); }
            if(event.data === 'stutem-classroom-expand') { minimized = false; frame.style.cssText = fullStyle; }
            if(minimized && typeof event.data === 'string' && event.data.charAt(0) === '{') {
              let move = null; try { move = JSON.parse(event.data); } catch {}
              if (move && move.type === 'stutem-classroom-move' && Number.isFinite(move.dx) && Number.isFinite(move.dy)) { miniLeft += move.dx; miniTop += move.dy; placeMini(); }
            }
            if(event.data === 'stutem-classroom-close') {
              try { sessionStorage.removeItem(storageKey); } catch {}
              window.removeEventListener('message',receive); window.removeEventListener('resize',resize); frame.remove();
              if (onClosed) onClosed(courseId || '', batchId || '');
            }
          }
          window.addEventListener('message',receive); window.addEventListener('resize',resize); host.appendChild(frame);
        },
        'com.stutem.app.classroom.__convertKotlinClosureToJsClosure_((String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((String,String)->Unit)'](f, p0, p1)),
        'com.stutem.app.device.webSerialSupported' : 
            () => {
              const ua = typeof navigator !== "undefined" ? (navigator.userAgent || "") : "";
              const chromium = (/Chrome\//.test(ua) || /Edg\//.test(ua)) && !/OPR\//.test(ua);
              const mobile = /Android|iPhone|iPad|Mobile/i.test(ua);
              let embedded = true;
              try { embedded = window.self !== window.top; } catch (_) { embedded = true; }
              return typeof window !== "undefined" && window.isSecureContext === true &&
                !embedded && chromium && !mobile && typeof navigator !== "undefined" && !!navigator.serial;
            }
            ,
        'com.stutem.app.device.webSerialAvailabilityMessage' : 
            () => {
              const ua = typeof navigator !== "undefined" ? (navigator.userAgent || "") : "";
              const chromium = (/Chrome\//.test(ua) || /Edg\//.test(ua)) && !/OPR\//.test(ua);
              const mobile = /Android|iPhone|iPad|Mobile/i.test(ua);
              let embedded = true;
              try { embedded = window.self !== window.top; } catch (_) { embedded = true; }
              if (typeof window === "undefined" || window.isSecureContext !== true) {
                return "Open the app over HTTPS or localhost before provisioning a board";
              }
              if (embedded) return "Open the app directly in a desktop Chrome or Edge tab";
              if (!chromium || mobile) return "USB provisioning works only in desktop Chrome or Edge";
              if (typeof navigator === "undefined" || !navigator.serial) {
                return "Web Serial is not available. Update Chrome or Edge and open the app directly";
              }
              return "Connect the ESP32 board by USB, then choose its serial port";
            }
            ,
        'com.stutem.app.device.provisionKitWithWebSerial' : 
            async (apiBaseUrl, authToken, courseId, hardwareRevision, hardwareSerial, hardwareBatch, reportProgress) => {
              let deviceName = "";
              const onProgress = (percent, message) => reportProgress(percent, message, deviceName);
              const messageFrom = async (response, fallback) => {
                const raw = await response.text();
                try { return JSON.parse(raw).message || fallback; } catch (_) { return raw || fallback; }
              };
              const post = (url, body) => fetch(url, {
                method: "POST",
                headers: {
                  "Authorization": "Bearer " + authToken,
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
              });
              let transport = null;
              let sessionId = "";
              let downloadToken = "";
              let flashingFinished = false;
              try {
                onProgress(2, "Choose the connected ESP32 USB port");
                const port = await navigator.serial.requestPort();
                const module = await import("esptool-js");
                onProgress(5, "Connecting to the board");
                transport = new module.Transport(port, false);
                const loader = new module.ESPLoader({
                  transport,
                  baudrate: 460800,
                  terminal: { clean() {}, writeLine() {}, write() {} },
                  debugLogging: false
                });
                const chipName = await loader.main();
                if (!String(chipName).toUpperCase().startsWith("ESP32")) {
                  throw new Error("The selected serial port is not a supported ESP32 board");
                }
                onProgress(10, "Reading board identity");
                const detectedMac = await loader.chip.readMac(loader);
                const compactMac = String(detectedMac || "").replace(/[^0-9A-Fa-f]/g, "").toUpperCase();
                if (compactMac.length === 12) deviceName = "StuTemKit-" + compactMac.slice(6);
                onProgress(12, deviceName ? "Found " + deviceName : "Reading board identity");
                const sessionResponse = await post(apiBaseUrl + "/api/firmware/web-provisioning/sessions", {
                  courseId,
                  detectedMac,
                  chipFamily: chipName,
                  hardwareRevision,
                  hardwareSerial,
                  hardwareBatch,
                  allowReprovision: true
                });
                if (!sessionResponse.ok) throw new Error(await messageFrom(sessionResponse, "Provisioning could not start"));
                const session = await sessionResponse.json();
                sessionId = session.sessionId;
                downloadToken = session.downloadToken;
                const firmware = session.firmware;
                onProgress(14, "Downloading base firmware");
                const binaryResponse = await fetch(apiBaseUrl + firmware.downloadPath, {
                  headers: {
                    "Authorization": "Bearer " + authToken,
                    "X-Stutem-Provisioning-Token": downloadToken
                  }
                });
                if (!binaryResponse.ok) throw new Error(await messageFrom(binaryResponse, "Base firmware download failed"));
                const buffer = await binaryResponse.arrayBuffer();
                const bytes = new Uint8Array(buffer);
                if (bytes.length !== Number(firmware.sizeBytes)) {
                  throw new Error("Downloaded firmware size does not match the provisioning manifest");
                }
                onProgress(18, "Verifying downloaded firmware");
                const digest = new Uint8Array(await crypto.subtle.digest("SHA-256", buffer));
                const sha256 = Array.from(digest).map((value) => value.toString(16).padStart(2, "0")).join("");
                if (sha256.toLowerCase() !== String(firmware.sha256).toLowerCase()) {
                  throw new Error("Downloaded firmware SHA-256 does not match the provisioning manifest");
                }
                onProgress(20, "Flashing base firmware");
                let lastFlashPercent = -1;
                await loader.writeFlash({
                  fileArray: [{ data: bytes, address: Number(firmware.flashOffset || 0) }],
                  flashMode: firmware.flashMode,
                  flashFreq: firmware.flashFrequency,
                  flashSize: firmware.flashSize,
                  eraseAll: false,
                  compress: true,
                  reportProgress: (_fileIndex, written, total) => {
                    const percent = 20 + Math.max(0, Math.min(70, Math.floor((written / Math.max(1, total)) * 70)));
                    if (percent !== lastFlashPercent) {
                      lastFlashPercent = percent;
                      onProgress(percent, "Flashing base firmware");
                    }
                  }
                });
                onProgress(92, "Restarting the board");
                await loader.after("hard_reset");
                flashingFinished = true;
                onProgress(96, "Registering the board with this course");
                const completeResponse = await post(
                  apiBaseUrl + "/api/firmware/web-provisioning/sessions/" + sessionId + "/complete",
                  { downloadToken }
                );
                if (!completeResponse.ok) {
                  return JSON.stringify({
                    message: "Firmware was flashed, but board registration failed: " +
                      await messageFrom(completeResponse, "try registration again"),
                    registrationPending: true,
                    pendingSessionId: sessionId,
                    pendingDownloadToken: downloadToken
                  });
                }
                const completed = await completeResponse.json();
                onProgress(100, "Board provisioned");
                return JSON.stringify({
                  deviceId: completed.deviceId || "",
                  deviceName: completed.deviceName || "",
                  firmwareId: completed.firmwareId || "",
                  message: "Board provisioned and added to this course",
                  registrationPending: false
                });
              } catch (error) {
                if (sessionId && downloadToken && !flashingFinished) {
                  try {
                    await post(
                      apiBaseUrl + "/api/firmware/web-provisioning/sessions/" + sessionId + "/failed",
                      { downloadToken, message: error && error.message ? error.message : "Web Serial provisioning failed" }
                    );
                  } catch (_) {}
                }
                throw error;
              } finally {
                if (transport) {
                  try { await transport.disconnect(); } catch (_) {}
                }
              }
            }
            ,
        'com.stutem.app.device.__convertKotlinClosureToJsClosure_((Int,String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Int,String,String)->Unit)'](f, p0, p1, p2)),
        'com.stutem.app.device.completePendingProvisioningViaFetch' : 
            async (apiBaseUrl, authToken, sessionId, downloadToken) => {
              const response = await fetch(
                apiBaseUrl + "/api/firmware/web-provisioning/sessions/" + sessionId + "/complete",
                {
                  method: "POST",
                  headers: {
                    "Authorization": "Bearer " + authToken,
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({ downloadToken })
                }
              );
              const raw = await response.text();
              if (!response.ok) {
                let message = raw || "Board registration failed";
                try { message = JSON.parse(raw).message || message; } catch (_) {}
                throw new Error(message);
              }
              return raw;
            }
            ,
        'com.stutem.app.device.hasWebBluetooth' : () => typeof navigator !== 'undefined' && !!navigator.bluetooth,
        'com.stutem.app.device.isIosWebBrowser' : () => typeof navigator !== 'undefined' && (/iPad|iPhone|iPod/i.test(navigator.userAgent || '') || (/Mac/i.test(navigator.platform || '') && navigator.maxTouchPoints > 1)),
        'com.stutem.app.device.webBluetoothAvailabilityMessage' : 
            () => {
              const platform = typeof navigator !== "undefined"
                ? ((navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || "")
                : "";
              const userAgent = typeof navigator !== "undefined" ? (navigator.userAgent || "") : "";
              const embedded = typeof window !== "undefined" && window.self !== window.top;
              if (typeof window === "undefined" || window.isSecureContext !== true) {
                return "Open this app over HTTPS or http://localhost; Web Bluetooth is blocked on plain HTTP/LAN addresses.";
              }
              if (embedded) {
                return "Open the app directly in a Chrome or Edge tab. Web Bluetooth is blocked in embedded previews.";
              }
              if (typeof navigator === "undefined" || !navigator.bluetooth) {
                const linuxHint = /linux/i.test(platform) || /linux/i.test(userAgent)
                  ? " On Linux, enable Chrome's Web Bluetooth or Experimental Web Platform features flag, then restart Chrome."
                  : "";
                return "Web Bluetooth is not exposed by this browser context. Platform: " + (platform || "unknown") + "." + linuxHint;
              }
              return "Select your StuTem kit in the browser Bluetooth chooser.";
            }
            ,
        'com.stutem.app.device.requestStutemKitDevice' : 
            () => navigator.bluetooth.requestDevice({
              filters: [
                { services: ["7f8d0001-2a6d-4f8a-9f2b-4f6f5354554d"] },
                { namePrefix: "StuTemKit-" }
              ],
              optionalServices: ["7f8d0001-2a6d-4f8a-9f2b-4f6f5354554d"]
            })
            ,
        'com.stutem.app.device.reuseOrRequestStutemKitDeviceFromGesture' : 
            (onSuccess, onFailure) => {
              console.info("[StuTemKit] checking for a previously authorized Web Bluetooth device");
              Promise.resolve(
                typeof navigator.bluetooth.getDevices === "function"
                  ? navigator.bluetooth.getDevices()
                  : []
              ).then((remembered) => {
                const device = remembered.find((item) =>
                  item && item.name && item.name.startsWith("StuTemKit-")
                );
                if (device) return device;
                console.info("[StuTemKit] opening Web Bluetooth chooser");
                return navigator.bluetooth.requestDevice({
                  filters: [
                    { services: ["7f8d0001-2a6d-4f8a-9f2b-4f6f5354554d"] },
                    { namePrefix: "StuTemKit-" }
                  ],
                  optionalServices: ["7f8d0001-2a6d-4f8a-9f2b-4f6f5354554d"]
                });
              }).then((device) => {
                console.info("[StuTemKit] Web Bluetooth device selected", device && device.name ? device.name : device && device.id);
                onSuccess(device);
              }).catch((error) => {
                console.warn("[StuTemKit] Web Bluetooth chooser failed", error && error.name, error && error.message);
                onFailure();
              });
            }
            ,
        'com.stutem.app.device.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
        'com.stutem.app.device.webBleDeviceId' : (device) => device && device.id ? device.id : '',
        'com.stutem.app.device.webBleDeviceName' : (device) => device && device.name ? device.name : '',
        'com.stutem.app.device.connectStutemKitDevice' : 
            (device, timeoutMs) => {
              const attempt = (device.__stutemConnectAttempt || 0) + 1;
              device.__stutemConnectAttempt = attempt;
              let timeoutId;
              let phase = "GATT connection";
              const operation = (async () => {
                const server = await device.gatt.connect();
                phase = "service discovery";
                const service = await server.getPrimaryService("7f8d0001-2a6d-4f8a-9f2b-4f6f5354554d");
                phase = "characteristic discovery";
                const command = await service.getCharacteristic("7f8d0002-2a6d-4f8a-9f2b-4f6f5354554d");
                const status = await service.getCharacteristic("7f8d0003-2a6d-4f8a-9f2b-4f6f5354554d");
                phase = "status subscription";
                await status.startNotifications();
                let initialStatus = "";
                try {
                  const value = await status.readValue();
                  initialStatus = new TextDecoder().decode(value);
                } catch (_) {}
                return { command, status, initialStatus };
              })();
              const timeout = new Promise((_, reject) => {
                timeoutId = setTimeout(() => {
                  if (device.__stutemConnectAttempt === attempt) {
                    try { device.gatt.disconnect(); } catch (_) {}
                  }
                  reject(new Error(phase + " timed out after " + timeoutMs + "ms"));
                }, timeoutMs);
              });
              return Promise.race([operation, timeout]).then((channels) => {
                clearTimeout(timeoutId);
                console.info("[StuTemKit] Web Bluetooth reconnect succeeded on attempt " + attempt);
                return channels;
              }).catch((error) => {
                clearTimeout(timeoutId);
                const detail = error && error.message ? error.message : String(error);
                console.warn("[StuTemKit] Web Bluetooth reconnect attempt " + attempt + " failed during " + phase + ": " + detail);
                throw error;
              });
            }
            ,
        'com.stutem.app.device.webBleCommandCharacteristic' : (channels) => channels ? channels.command : null,
        'com.stutem.app.device.webBleStatusCharacteristic' : (channels) => channels ? channels.status : null,
        'com.stutem.app.device.webBleInitialStatus' : (channels) => channels && typeof channels.initialStatus === 'string' ? channels.initialStatus : '',
        'com.stutem.app.device.prepareWebBleReconnect' : 
            async (device, timeoutMs) => {
              let candidate = device;
              try {
                if (navigator.bluetooth && typeof navigator.bluetooth.getDevices === "function") {
                  const remembered = await navigator.bluetooth.getDevices();
                  candidate = remembered.find((item) => item.id === device.id) ||
                    remembered.find((item) => item.name && item.name === device.name) ||
                    device;
                }
              } catch (_) {}
              if (!candidate || (candidate.gatt && candidate.gatt.connected) ||
                  typeof candidate.watchAdvertisements !== "function") {
                return candidate;
              }
              console.info("[StuTemKit] Waiting for the restarted kit to advertise");
              await new Promise((resolve) => {
                let settled = false;
                let timeoutId;
                const controller = typeof AbortController === "function" ? new AbortController() : null;
                const finish = (advertised) => {
                  if (settled) return;
                  settled = true;
                  clearTimeout(timeoutId);
                  candidate.removeEventListener("advertisementreceived", onAdvertisement);
                  if (controller) controller.abort();
                  console.info(advertised
                    ? "[StuTemKit] Restarted kit advertisement received"
                    : "[StuTemKit] Advertisement wait ended; attempting GATT connection");
                  resolve();
                };
                const onAdvertisement = () => finish(true);
                candidate.addEventListener("advertisementreceived", onAdvertisement);
                const options = controller ? { signal: controller.signal } : undefined;
                Promise.resolve(candidate.watchAdvertisements(options)).catch(() => finish(false));
                timeoutId = setTimeout(() => finish(false), timeoutMs);
              });
              return candidate;
            }
            ,
        'com.stutem.app.device.setWebBleStatusListener' : 
            (status, callback) => {
              if (status.__stutemStatusListener) {
                status.removeEventListener("characteristicvaluechanged", status.__stutemStatusListener);
              }
              const listener = (event) => {
                callback(new TextDecoder().decode(event.target.value));
              };
              status.__stutemStatusListener = listener;
              status.addEventListener("characteristicvaluechanged", listener);
            }
            ,
        'com.stutem.app.device.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
        'com.stutem.app.device.setWebBleDisconnectListener' : 
            (device, callback) => {
              if (device.__stutemDisconnectListener) {
                device.removeEventListener("gattserverdisconnected", device.__stutemDisconnectListener);
              }
              const listener = () => callback();
              device.__stutemDisconnectListener = listener;
              device.addEventListener("gattserverdisconnected", listener);
            }
            ,
        'com.stutem.app.device.writeWebBleCommand' : 
            (command, payload) => {
              const bytes = new TextEncoder().encode(payload);
              return command.writeValueWithResponse
                ? command.writeValueWithResponse(bytes)
                : command.writeValue(bytes);
            }
            ,
        'com.stutem.app.device.writeWebBleBinaryChunk' : 
            (command, payloadBase64) => {
              const raw = atob(payloadBase64);
              const bytes = new Uint8Array(raw.length);
              for (let index = 0; index < raw.length; index += 1) bytes[index] = raw.charCodeAt(index);
              return command.writeValueWithResponse
                ? command.writeValueWithResponse(bytes)
                : command.writeValue(bytes);
            }
            ,
        'com.stutem.app.device.readWebBleStatus' : 
            async (status) => {
              const value = await status.readValue();
              return new TextDecoder().decode(value);
            }
            ,
        'com.stutem.app.device.disconnectWebBleDevice' : (device) => { try { if (device && device.gatt) device.gatt.disconnect(); } catch (_) {} },
        'com.stutem.app.device.isWebBleDeviceConnected' : (device) => !!(device && device.gatt && device.gatt.connected),
        'com.stutem.app.device.isSameWebBleDevice' : (first, second) => first === second,
        'com.stutem.app.logging.WasmDate_$external_fun' : () => new Date(),
        'com.stutem.app.logging.toISOString_$external_fun' : (_this, ) => _this.toISOString(),
        'com.stutem.app.media.webOrigin' : () => window.location.origin,
        'com.stutem.app.media.rewriteSameSiteAliasUrl' : (url, currentOrigin) => {
                try {
                  const target = new URL(url);
                  const current = new URL(currentOrigin);
                  const normalize = (host) => String(host || '').replace(/^www\./i, '').toLowerCase();
                  if (target.protocol !== current.protocol) return url;
                  if (normalize(target.hostname) !== normalize(current.hostname)) return url;
                  return `${currentOrigin}${target.pathname}${target.search}${target.hash}`;
                } catch (_) {
                  return url;
                }
              },
        'com.stutem.app.media.fetchBinary' : (url, timeoutMs) => {
                const controller = new AbortController();
                const timer = setTimeout(() => controller.abort(), timeoutMs);
                return fetch(url, { method: 'GET', signal: controller.signal })
                  .finally(() => clearTimeout(timer));
              },
        'com.stutem.app.media.responseOk' : (response) => !!response.ok,
        'com.stutem.app.media.responseArrayBuffer' : (response) => response.arrayBuffer(),
        'com.stutem.app.media.arrayBufferLength' : (buffer) => new Int8Array(buffer).length,
        'com.stutem.app.media.arrayBufferByteAt' : (buffer, index) => new Int8Array(buffer)[index],
        'com.stutem.app.state.isDocumentHidden' : () => typeof document !== 'undefined' && document.hidden === true,
        'com.stutem.app.upload.arrayBufferLength' : (buffer) => new Int8Array(buffer).length,
        'com.stutem.app.upload.arrayBufferByteAt' : (buffer, index) => new Int8Array(buffer)[index],
        'com.stutem.app.upload.uploadViaFetchJson' : 
            (uploadUrl, authToken, actorUserId, purpose, courseId, topicId, kind, filename, mimeType, base64) =>
              fetch(uploadUrl, {
                method: "POST",
                headers: {
                  "Authorization": "Bearer " + authToken,
                  "X-Stutem-Actor-User-Id": actorUserId,
                  "X-Stutem-Upload-Purpose": purpose,
                  "X-Stutem-Course-Id": courseId,
                  "X-Stutem-Topic-Id": topicId,
                  "X-Stutem-Upload-Kind": kind,
                  "X-Stutem-Filename": filename,
                  "X-Stutem-Mime-Type": mimeType,
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({ base64 })
              })
            ,
        'com.stutem.app.upload.uploadActivityFirmwareViaFetchJson' : 
            async (uploadUrl, authToken, actorUserId, firmwareTitleBase64, contentItemId, courseId, baseFirmwareId, hardwareRequirementsBase64, wiringBase64, outcomeBase64, isCurrent, replacesFirmwareId, filename, mimeType, base64) => {
              const key = actorUserId.trim().toLowerCase() + ":" + courseId.trim().toLowerCase();
              const controllers = globalThis.__stutemFirmwareUploadControllers ||
                (globalThis.__stutemFirmwareUploadControllers = new Map());
              const prior = controllers.get(key);
              if (prior) prior.abort();
              const controller = new AbortController();
              controllers.set(key, controller);
              try {
                const response = await fetch(uploadUrl, {
                  method: "POST",
                  signal: controller.signal,
                  headers: {
                    "Authorization": "Bearer " + authToken,
                    "X-Stutem-Actor-User-Id": actorUserId,
                    "X-Stutem-Firmware-Title-Base64": firmwareTitleBase64,
                    "X-Stutem-Content-Item-Id": contentItemId,
                    "X-Stutem-Course-Id": courseId,
                    "X-Stutem-Base-Firmware-Key": baseFirmwareId,
                    "X-Stutem-Hardware-Requirements-Base64": hardwareRequirementsBase64,
                    "X-Stutem-Wiring-Base64": wiringBase64,
                    "X-Stutem-Outcome-Base64": outcomeBase64,
                    "X-Stutem-Is-Current": isCurrent,
                    "X-Stutem-Replaces-Firmware-Key": replacesFirmwareId,
                    "X-Stutem-Filename": filename,
                    "X-Stutem-Mime-Type": mimeType,
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({ base64 })
                });
                response.__stutemFirmwareUploadKey = key;
                response.__stutemFirmwareUploadController = controller;
                return response;
              } catch (error) {
                if (controllers.get(key) === controller) controllers.delete(key);
                throw error;
              }
            }
            ,
        'com.stutem.app.upload.abortActivityFirmwareUpload' : 
            (actorUserId, courseId) => {
              const key = actorUserId.trim().toLowerCase() + ":" + courseId.trim().toLowerCase();
              const controllers = globalThis.__stutemFirmwareUploadControllers;
              const controller = controllers && controllers.get(key);
              if (!controller) return false;
              controllers.delete(key);
              controller.abort();
              return true;
            }
            ,
        'com.stutem.app.upload.rebuildActivityFirmwareViaFetch' : 
            (rebuildUrl, authToken, courseId, firmwareId) =>
              fetch(rebuildUrl, {
                method: "POST",
                headers: {
                  "Authorization": "Bearer " + authToken,
                  "X-Stutem-Course-Id": courseId,
                  "X-Stutem-Firmware-Key": firmwareId
                }
              })
            ,
        'com.stutem.app.upload.downloadFirmwareSourceViaFetch' : 
            async (downloadUrl, authToken, fileName) => {
              const response = await fetch(downloadUrl, {
                method: "GET",
                headers: { "Authorization": "Bearer " + authToken }
              });
              if (!response.ok) {
                const raw = await response.text();
                try {
                  const parsed = JSON.parse(raw);
                  return parsed.message || "Firmware source download failed";
                } catch (_) {
                  return raw || "Firmware source download failed";
                }
              }
              const objectUrl = URL.createObjectURL(await response.blob());
              try {
                const anchor = document.createElement("a");
                anchor.href = objectUrl;
                anchor.download = fileName;
                anchor.style.display = "none";
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove();
              } finally {
                URL.revokeObjectURL(objectUrl);
              }
              return "";
            }
            ,
        'com.stutem.app.upload.fetchFirmwareSourceForEditing' : 
            (downloadUrl, authToken) => fetch(downloadUrl, {
              method: "GET",
              headers: { "Authorization": "Bearer " + authToken }
            })
            ,
        'com.stutem.app.upload.responseOk' : (response) => !!response.ok,
        'com.stutem.app.upload.responseText' : 
            async (response) => {
              try {
                return await response.text();
              } finally {
                const key = response && response.__stutemFirmwareUploadKey;
                const controller = response && response.__stutemFirmwareUploadController;
                const controllers = globalThis.__stutemFirmwareUploadControllers;
                if (key && controllers && controllers.get(key) === controller) controllers.delete(key);
              }
            }
        
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './stutem-composeApp.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],


    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject, { builtins: [''] });
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./stutem-composeApp.wasm',import.meta.url).href), importObject, { builtins: [''] })).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
